/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import {
    shape, object, string, bool, arrayOf,
} from 'prop-types';

import { getFeatureFlags } from '../../../utils/featureSelectors';
import { dateMMMMDDYYYY } from '../../../utils/dateString';
import Helper from '../../../state/reducers/Helper';

const DeliveryDate = ({ ROSSOrder, isROSSPassport }) => {

   const isShowFlexLabelEnabled = useSelector(getFeatureFlags)['is-show-flex-label-enabled']
   const ROSSPassportDeliveryDate = dateMMMMDDYYYY(ROSSOrder?.billingProfile?.orderDate);

   const deliveryHelper = (
      {
         arrivalStartDate,
         arrivalEndDate,
         flexGuaranteedFlag,
         flexMessage,
         flexDate,
         deliveryDate,
         itemType,
      },
      estimatedDeliveryDate,
   ) => {
      const productBrand = ROSSOrder?.items?.[0]?.productBrand;
      const exactDeliveryDate = deliveryDate || '';
      const isflexDate = flexDate !== '' && flexMessage !== '' && flexGuaranteedFlag === 'N';

      const deliveryData = Helper.getDeliveryDate(exactDeliveryDate, arrivalStartDate, arrivalEndDate, productBrand, isflexDate, estimatedDeliveryDate);
      const deliveryLabel = deliveryData.deliveryLabel || '';
      const deliveryDateText = deliveryData.deliveryDate || '';

      return (
         <>
               <div className="bold">{deliveryLabel} {deliveryDateText}</div>
               {
                  itemType === 'FPT' && flexGuaranteedFlag === 'N' && flexMessage !== '' && (
                     <div className="align-left">
                           {isShowFlexLabelEnabled && <> {flexMessage} </>}
                     </div>
                  )
               }
         </>
      );
   };

   return (
      <>
            {isROSSPassport ? (
               <h2 className="gray-color no-margin-top">
                  Membership Start Date:
                  <span className="normal body-color no-uppercase">
                        {` ${ROSSPassportDeliveryDate}`}
                  </span>
               </h2>
            ) : (
               <>
                  <h2 className="gray-color no-margin-top">
                        <div className="split align-center">
                           <div className="align-left">
                              Delivery Date
                           </div>
                        </div>
                  </h2>
                  {deliveryHelper(
                        ROSSOrder.items[0],
                        ROSSOrder.estimatedDeliveryDate,
                  )}
                  {ROSSOrder?.items?.[0]?.dtwName
                        && (
                           <>
                              <h2 className="gray-color">
                                    <div className="split align-center">
                                       <div className="align-left">
                                          Requested Time
                                       </div>
                                    </div>
                              </h2>
                              <div>{ROSSOrder?.items?.[0]?.dtwName}</div>
                           </>
                        )}
               </>
            )}
      </>
   )
}

DeliveryDate.defaultProps = {
    isROSSPassport: false,
    ROSSOrder: {},
};

DeliveryDate.propTypes = {
    isROSSPassport: bool,
    ROSSOrder: shape({
        history: arrayOf(shape({
            codeStatus: string,
            createdDate: string,
            location: object,
            status: string,
            statusDescription: string,
        })),
        intOrderNumber: string,
        items: arrayOf(shape({
            productBrand: string,
            itemType: string,
            productName: string,
            productSku: string,
        })),
        origin: string,
        recipientFirstName: string,
        recipientLastName: string,
        signatureImageURL: string,
        status: string,
        statusDescription: string,
        trackingNumber: string,
        type: string,
        warningMessage: string,
    }),
};

export default DeliveryDate;
